let idCounter = 0;

export const generateID = (prefix: string = ''): string => `flipster-${prefix}${(idCounter += 1)}`;
